import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { AuthHttp } from './core/auth-http.service';

@Injectable()
export class SharedService {

  private dataObs$ = new Subject();

  private $userType = new ReplaySubject(1);
    constructor(private http: AuthHttp) {
      this.$userType.next('notDefined');
    }

    getData() {
        return this.dataObs$;
    }

    updateData(data: boolean) {
        this.dataObs$.next(data);
    }

    getUserType() {
      return this.$userType;
    }

    updateUserType(userType) {
      this.$userType.next(userType);
    }

    changeSessionData(sessionData) {
      return this.http.post('user/sessionData', sessionData)
       .map(response => response.json());
     }
}



// WEBPACK FOOTER //
// ./src/app/shared.service.ts